function obradiUDrugojNiti(poruka, prijenos = []) {
  return new Promise((rijesi, odbij) => {
    const radnik = new Worker(
      new URL('./ucitajExcelRadnik.js', import.meta.url),
      { type: 'module' },
    );
    const vrijeme = setTimeout(() => {
      radnik.terminate();
      odbij(new Error('Obrada traje predugo. Pokušaj s manjom datotekom.'));
    }, 20000);
    const zavrsi = () => {
      clearTimeout(vrijeme);
      radnik.terminate();
    };
    radnik.onmessage = ({ data }) => {
      zavrsi();
      data.greska ? odbij(new Error(data.greska)) : rijesi(data);
    };
    radnik.onerror = () => {
      zavrsi();
      odbij(
        new Error(
          'Excel se nije mogao pročitati. Provjeri datoteku i pokušaj ponovno.',
        ),
      );
    };
    radnik.postMessage(poruka, prijenos);
  });
}
export async function ucitajExcel(datoteka) {
  if (!/\.(xlsx|xls)$/i.test(datoteka.name))
    throw new Error('Odaberi Excel datoteku s nastavkom .xlsx ili .xls.');
  if (datoteka.size > 5 * 1024 * 1024)
    throw new Error('Najveća dopuštena veličina datoteke je 5 MB.');
  const buffer = await datoteka.arrayBuffer();
  return (await obradiUDrugojNiti({ buffer }, [buffer])).listovi;
}
export async function preuzmiPredlozak() {
  const { buffer } = await obradiUDrugojNiti({ tip: 'predlozak' });
  const adresa = URL.createObjectURL(
    new Blob([buffer], {
      type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    }),
  );
  const poveznica = document.createElement('a');
  poveznica.href = adresa;
  poveznica.download = 'predlozak-kucanstva.xlsx';
  poveznica.click();
  setTimeout(() => URL.revokeObjectURL(adresa), 1000);
}
